'use client'

/**
 * Google Ads event helpers (remarketing).
 *
 * Purchase conversion tracking lives in OrderTracking.js on the order
 * confirmation page. Everything here no-ops when NEXT_PUBLIC_GAAW_ID is unset
 * (dev machines), matching the rest of the tracking config.
 */

import { GAAW_ID } from '@/app/_lib/config/tracking'
import { gtag } from '@/app/_lib/analytics/gtag'

/**
 * Dynamic remarketing page_view — tells Google Ads which product was viewed so
 * dynamic product ads can retarget with it. Ports the legacy PHP header event
 * (public.header.php: ecomm_pagetype/ecomm_prodid on product pages).
 */
export function trackAdsProductView(subProductId) {
    if (!GAAW_ID || !subProductId) return
    gtag('event', 'page_view', {
        send_to: GAAW_ID,
        ecomm_pagetype: 'product',
        ecomm_prodid: String(subProductId),
    })
}
